"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardCompatibility = void 0;
const not_edge_desktop_1 = require("./not-edge-desktop");
const not_ie_1 = require("./not-ie");
function standardCompatibility(client) {
    return not_ie_1.notIE(client) && not_edge_desktop_1.notEdgeDesktop(client);
}
exports.standardCompatibility = standardCompatibility;
//# sourceMappingURL=standard-compatibility.js.map